import { render, staticRenderFns } from "./excludedCustomers.vue?vue&type=template&id=55cf95bc&scoped=true&"
import script from "./excludedCustomers.vue?vue&type=script&lang=js&"
export * from "./excludedCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cf95bc",
  null
  
)

export default component.exports